var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "modal",
      staticClass: "terms-conditions",
      attrs: {
        modalType: "large-modal",
        showCloseBtn: false,
        modalId: _vm.modalId,
      },
    },
    [
      _c("div", { staticClass: "terms-conditions__title" }, [
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("terms." + _vm.regionName + ".tenantProjects.title"))
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "terms-conditions__content" }, [
        _c("div", { staticClass: "terms-conditions__general" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("terms." + _vm.regionName + ".tenantProjects.general")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "terms-conditions__general",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("terms." + _vm.regionName + ".tenantProjects.generalCH")
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "ol",
          { staticClass: "terms-conditions__list" },
          _vm._l(
            _vm.$t("terms." + _vm.regionName + ".tenantProjects.content"),
            function (item, key) {
              return _c(
                "li",
                { key: key, staticClass: "terms-conditions__item" },
                [_c("span", { domProps: { innerHTML: _vm._s(item) } })]
              )
            }
          ),
          0
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "terms-conditions__general",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("terms." + _vm.regionName + ".tenantProjects.remarks")
            ),
          },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "terms-conditions__general",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t(
                "terms." + _vm.regionName + ".tenantProjects.remarkGeneral"
              )
            ),
          },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "terms-conditions__general",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("terms." + _vm.regionName + ".tenantProjects.remarkGenCH")
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticClass:
              "terms-conditions__list terms-conditions__list--remarks",
          },
          _vm._l(
            _vm.$t("terms." + _vm.regionName + ".tenantProjects.remarkContent"),
            function (item, key) {
              return _c(
                "li",
                { key: key, staticClass: "terms-conditions__item" },
                [_c("span", { domProps: { innerHTML: _vm._s(item) } })]
              )
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      !_vm.isNewProject
        ? _c("div", { staticClass: "terms-conditions__acceptance" }, [
            _vm.tncAcceptance.tenantUser
              ? _c("div", [
                  _c("div", [
                    _c("span", { staticClass: "company-name" }, [
                      _vm._v(_vm._s(_vm.tncAcceptance.tenantUser.companyName)),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "terms." + _vm.regionName + ".tenantProjects.agree"
                          )
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "agreed-info" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "terms." +
                              _vm.regionName +
                              ".tenantProjects.agreedby",
                            [
                              _vm.tncAcceptance.tenantUser.name,
                              _vm.formatDate(
                                _vm.tncAcceptance.tenantUser.acceptAt
                              ),
                            ]
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tncAcceptance.mainContractor
              ? _c("div", { staticClass: "main-contractor" }, [
                  _c("div", [
                    _c("span", { staticClass: "company-name" }, [
                      _vm._v(
                        _vm._s(_vm.tncAcceptance.mainContractor.companyName)
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "terms." + _vm.regionName + ".tenantProjects.agree"
                          )
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "agreed-info" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "terms." +
                              _vm.regionName +
                              ".tenantProjects.agreedby",
                            [
                              _vm.tncAcceptance.mainContractor.name,
                              _vm.formatDate(
                                _vm.tncAcceptance.mainContractor.acceptAt
                              ),
                            ]
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowCheckbox
        ? _c(
            "div",
            {
              staticClass: "terms-conditions__checkbox",
              class: _vm.errorHighlight ? "error-highlight" : "",
            },
            [
              _c("input", {
                staticClass: "checkbox__input",
                attrs: { id: "terms-conditions-input", type: "checkbox" },
                domProps: { checked: _vm.isAccepted },
                on: {
                  change: function ($event) {
                    return _vm.updateAcceptance()
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "terms-conditions-input" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "terms." + _vm.regionName + ".tenantProjects.onBehalf"
                      )
                    )
                ),
                _c("span", { staticClass: "company-name" }, [
                  _vm._v(_vm._s(_vm.company.name + ",")),
                ]),
                _vm._v(
                  _vm._s(
                    _vm.$t("terms." + _vm.regionName + ".tenantProjects.i")
                  ) +
                    " " +
                    _vm._s(
                      _vm.$t(
                        "terms." + _vm.regionName + ".tenantProjects.agree"
                      )
                    )
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowCheckbox
        ? _c(
            "div",
            {
              staticClass: "terms-conditions__btns",
              attrs: { slot: "btns" },
              slot: "btns",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.skip()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("action.cancel")) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { type: "button", disabled: !_vm.isAccepted },
                  on: {
                    click: function ($event) {
                      return _vm.accept()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("action.accept")) + "\n    "
                  ),
                ]
              ),
            ]
          )
        : _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("action.ok")) + "\n    ")]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }